export const BOOKING_HORIZON_DAYS = 14;
